import urls from 'urls';
import {apiClient} from '~/api/api-client';
import {FAVORITE_TEMPLATE, INIT_FAVORITES} from '~/GalleryPB/reducers/favorites';

// Fetch the existing favorites for the logged-in user
export const fetchAllFavoritesThunk = async (dispatch) => {
  const response = await apiClient.get(urls.get('ajax_gallery_favorites'));
  const data = await response.json();
  dispatch({
    type: INIT_FAVORITES,
    payload: {
      favorites: [
        ...data.pm_templates.map((t) => t.template_id),
        ...data.templates.map((t) => t.template_id),
      ],
    },
  });
};

/**
 * Toggle the favorited status for a gallery template
 * @param identifier the identifier for the template
 * @param premium whether or not the template is a premium template
 * @param method "post" or "delete" this favorite
 */
export const favoriteTemplateThunk = (identifier, premium, method) => async (dispatch) => {
  // Build the request
  const url = urls.get('ajax_gallery_favorites');
  const body = {
    template: identifier,
    plus: premium,
  };

  // Send the request
  fetch(url, {
    method: method.toUpperCase(),
    body: JSON.stringify(body),
    credentials: 'include',
    headers: {
      'X-CSRFToken': evite.cookie('csrftoken'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(() => {
      // Save the favorited template to the Redux state
      dispatch({
        type: FAVORITE_TEMPLATE,
        payload: {name: identifier},
      });
    })
    .catch(evite.error);
};
